/*******************************************************************************
* @ngdoc service
* @name  csm.books.StoreAdmin.service:AppConfig
*
* @description 
* Configuration settings for module `csm.books.AppConfig`. Settings may be
* changed in application `.config` blocks.
*
* Adds `SERVER` and `AppConfig` constants to `$rootScope` to make settings
* available to all template scopes from `$root`.
*
* Note: Configuration property settings are sealed so no properties can be
*       added. Setting a property other than those listed here will fail
*       silently or throw a TypeError if 'use strict' is set.
*******************************************************************************/
/* @ngInject */ export function AppConfigProvider($injector) {
  var $prov = this;
  $prov.configProperties = Object.keys(Object.assign($prov, defaults()));
  $prov.$get = $injector.invoke(service, this, { $prov: $prov });
  Object.seal($prov);
}

/*******************************************************************************
 * defaults - Returns default settings for all configuration properties. No other
 * properties are added to the AppConfig service.
 *******************************************************************************/
/* @ngInject */ function defaults() {
  /**
   * @ngdoc        property
   * @name         ourOrgMenuOptionName
   * @description
   * Name of the "Our Org" admin application option.
   */
  return {
    ourOrgMenuOptionName: undefined
  }
}

/*****************************************************************************
 * service */
/**
 * Finishes configuration and publishes configuration settings.
 *****************************************************************************/
/* @ngInject */ function service($prov) {
  return function ($rootScope, SERVER) {
    if (!$prov.ourOrgMenuOptionName)
      throw 'AppConfigProvider.ourOrgMenuOptionName not set.';

    /*----------------------------------------*/
    /* Make server constants available in     */
    /* all template scopes as `$root.SERVER`. */
    /*----------------------------------------*/
    $rootScope.SERVER = SERVER;

    /*----------------------------------------------*/
    /* Return configuration and make it available   */
    /* in all template scopes as `$root.AppConfig`. */
    /*----------------------------------------------*/
    return ($rootScope.AppConfig = $prov.configProperties.reduce(function (
      props,
      p
    ) {
      props[p] = $prov[p];
      return props;
    }, {}));
  };
}
